module.exports = __webpack_public_path__ + "img/1930aab.png";